<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    :value="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    mini-variant-width="80"
    width="260"
    v-bind="$attrs"
  >
    <template #img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        :src="barImage"
        v-bind="props"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular display-2 text-center">
          <!-- <span class="logo-mini">{{ $t('ct') }}</span> -->
          <span class="logo-normal">{{ $t('dashboard') }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <base-item-group :item="profile" />
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- httpsgithub.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- httpsgithub.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',
    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({

    }),

    computed: {
      ...mapState('app', ['barColor', 'drawer', 'barImage']),
      computedItems () {
        return this.sidebarItems.map(this.mapItem)
      },
      sidebarItems () {
        const testingItem = []
        if (this.$can('write', 'testing')) {
          testingItem.push({
            title: this.$t('router.test-scenario'),
            to: 'testing',
          })
        }
        if (this.$can('read', 'testing')) {
          testingItem.push({
            title: this.$t('router.test-results'),
            to: 'testing_results',
          })
        }
        const items = [{
          icon: 'mdi-chart-areaspline',
          title: this.$t('router.statistics'),
          to: '/',
        }]
        if (this.$can('read', 'domain')) {
          items.push({
            icon: 'mdi-vector-link',
            title: this.$t('router.domains'),
            to: '/pages/domains',
          })
        }
        if (this.$can('read', 'userlist')) {
          items.push({
            icon: 'mdi-account-multiple',
            title: this.$t('router.user-managment'),
            to: '/pages/manage',
          })
        }
        if (this.$can('read', 'logs')) {
          items.push({
            icon: 'mdi-notebook-check-outline',
            title: this.$t('router.logs'),
            to: '/pages/logs',
          })
        }
        if (this.$can('read', 'changelog')) {
          items.push({
            icon: 'mdi-gitlab',
            title: this.$t('router.changelog'),
            to: '/pages/changelog',
          })
        }

        if (this.$can('read', 'testing') || this.$can('write', 'testing')) {
          items.push({
            group: '/pages',
            icon: 'mdi-test-tube-empty',
            title: this.$t('router.testing'),
            children: testingItem,
          })
        }
        items.push({
          group: '/pages',
          icon: 'mdi-frequently-asked-questions',
          title: this.$t('router.faq'),
          children: [
            {
              title: this.$t('router.create'),
              to: 'faq_create',
            },
            {
              title: this.$t('router.list'),
              to: 'faq_list',
            },
            {
              title: 'FAQ-I',
              to: 'faq_i',
            },
          ],
        })

        return items
      },
      profile () {
        const children = [
          {
            to: 'pages/user',
            title: this.$t('my-profile'),
          },
        ]

        return {
          avatar: true,
          avatarUrl: this.getAvatar,
          group: '',
          title: this.getDisplayName,
          children: children,
        }
      },
      user () {
        return this.$store.state.user.user
      },
      getDisplayName () {
        if (this.user) {
          if (this.user.firstName && this.user.lastName) {
            return this.user.firstName + ' ' + this.user.lastName
          } else if (this.user.email) {
            return this.user.email
          }
        }
        return ''
      },
      getAvatar () {
        if (this.user) {
          if (this.user.customPhotoURL) {
            return this.user.customPhotoURL
          } else if (this.user.photoURL) {
            return this.user.photoURL
          }
        }
        return './favicon.png'
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
      drawer (val) {
        this.$store.commit('app/SET_DRAWER', val)
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
